import { gql } from '@apollo/client';

export const FIND_SUPPLY_CHAIN_BY_STRATEGY = gql`
  query FindSupplyChainByStrategy($uuid: ID!) {
    findSupplyChainByStrategy(uuid: $uuid) {
      inBoundShipmentSummary
      inBoundSummary
      increaseInboundCost
      increaseOutboundCost
      outBoundShipmentSummary
      outBoundSummary
      uuid
    }
  }
`;

export const UPDATE_SUPPLY_CHAIN = gql`
  mutation UpdateSupplyChain($data: UpdateSupplyChainInput!) {
    updateSupplyChain(data: $data) {
      inBoundShipmentSummary
      inBoundSummary
      increaseInboundCost
      increaseOutboundCost
      outBoundShipmentSummary
      outBoundSummary
      uuid
    }
  }
`;

export const FIND_ALL_INBOUND_MATERIALS_BY_SUPPLY_CHAIN = gql`
  query FindAllInboundMaterialsBySupplyChain($uuid: ID!) {
    findAllInboundMaterialsBySupplyChain(uuid: $uuid) {
      internalContactFirstName
      internalContactLastName
      internalEmail
      materialTypeName
      newDestination
      shippingMethod
      supplierName
      uuid
    }
  }
`;

export const CREATE_INBOUND_MATERIAL = gql`
  mutation InboundMaterial($data: CreateInboundMaterialInput!) {
    createInboundMaterial(data: $data) {
      internalContactFirstName
      internalContactLastName
      internalEmail
      materialTypeName
      newDestination
      shippingMethod
      supplierName
      uuid
    }
  }
`;

export const UPDATE_INBOUND_MATERIAL = gql`
  mutation InboundMaterial($data: UpdateInboundMaterialInput!) {
    updateInboundMaterial(data: $data) {
      internalContactFirstName
      internalContactLastName
      internalEmail
      materialTypeName
      newDestination
      shippingMethod
      supplierName
      uuid
    }
  }
`;

export const DELETE_INBOUND_MATERIAL = gql`
  mutation DeleteInboundMaterial($uuid: ID!) {
    deleteInboundMaterial(uuid: $uuid) {
      internalContactFirstName
      internalContactLastName
      internalEmail
      materialTypeName
      newDestination
      shippingMethod
      supplierName
      uuid
    }
  }
`;

export const FIND_ALL_OUTBOUND_MATERIALS_BY_SUPPLY_CHAIN = gql`
  query FindAllOutboundMaterialsBySupplyChain($uuid: ID!) {
    findAllOutboundMaterialsBySupplyChain(uuid: $uuid) {
      email
      firstName
      lastName
      materialTypeName
      commentary
      uuid
    }
  }
`;

export const CREATE_OUTBOUND_MATERIAL = gql`
  mutation OutboundMaterial($data: CreateOutboundMaterialInput!) {
    createOutboundMaterial(data: $data) {
      email
      firstName
      lastName
      materialTypeName
      commentary
      uuid
    }
  }
`;

export const UPDATE_OUTBOUND_MATERIAL = gql`
  mutation OutboundMaterial($data: UpdateOutboundMaterialInput!) {
    updateOutboundMaterial(data: $data) {
      email
      firstName
      lastName
      materialTypeName
      commentary
      uuid
    }
  }
`;

export const DELETE_OUTBOUND_MATERIAL = gql`
  mutation DeleteOutboundMaterial($uuid: ID!) {
    deleteOutboundMaterial(uuid: $uuid) {
      email
      firstName
      lastName
      materialTypeName
      commentary
      uuid
    }
  }
`;
